import { Sidebar, SidebarItem } from '@hourly/components/Sidebar';
import { useAuth } from '@hourly/contexts/AuthContext';
import { ReleaseTogglesProvider } from '@hourly/contexts/ReleaseTogglesContext';
import { RoleActionsProvider } from '@hourly/contexts/RoleActionsContext';
import { PriceLine, SettingsLine, UserGroupLine, UserLine } from '@hourly-hds/icons/glyph';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router';
import Header from '@shared/components/Header';
import api from '~/api';
import { envConfigs } from '~/envConfigs';
import useEventGateway from '~/routes/_shared/events/useEventGateway';
import DialogProvider from '../referrals/_shared/components/Dialog/DialogProvider';
import styles from './AppLayout.module.css';
import Layout from './components/Layout';
import VersionBadge from './components/VersionBadge';

const SidebarMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const items: SidebarItem[] = [
    {
      key: '/referrals',
      leftDecoration: <UserLine />,
      label: 'Referrals',
      children: [
        {
          key: '/referrals/active',
          label: 'Active',
        },
        {
          key: '/referrals/lost',
          label: 'Lost',
        },
      ],
    },
    {
      key: '/customers',
      leftDecoration: <UserGroupLine />,
      label: 'Customers',
      children: [
        {
          key: '/customers/live',
          label: 'Live',
        },
        {
          key: '/customers/churned',
          label: 'Churned',
        },
      ],
    },
    {
      key: '/revenue-share',
      leftDecoration: <PriceLine />,
      label: 'Revenue Share',
    },
    {
      key: '/settings',
      leftDecoration: <SettingsLine />,
      label: 'Settings',
    },
  ];

  return (
    <Sidebar
      items={items}
      selectedItem={location.pathname.replace(/\/$/, '')}
      onChange={(selectedItem) => navigate(selectedItem)}
    />
  );
};
export default function AppLayout() {
  useEventGateway();
  const { isLoggedIn, sessionState } = useAuth();

  if (!isLoggedIn) {
    return <Navigate to="/logout" />;
  }

  if (sessionState.isInOnboarding) {
    return <Navigate to="/onboarding" />;
  }

  return (
    <DialogProvider>
      <ReleaseTogglesProvider api={api}>
        <RoleActionsProvider api={api}>
          <Layout>
            <Layout.Header>
              <div className={styles.headerWrap}>
                <Header name={`${sessionState.firstName} ${sessionState.lastName}`} />
              </div>
            </Layout.Header>
            <Layout.Content>
              <Layout.Sider>
                <SidebarMenu />
              </Layout.Sider>
              <Outlet />
            </Layout.Content>
          </Layout>
          {envConfigs.showBuildVersions && <VersionBadge />}
        </RoleActionsProvider>
      </ReleaseTogglesProvider>
    </DialogProvider>
  );
}
